export const TASK_OWNER = "TASK_OWNER"; // I am actual task owner
export const TASK_OWNER_THREAD = "TASK_OWNER_THREAD";
export const TASK_VISITOR = "TASK_VISITOR"; // I am only task visitor
export const TASK_LAST_OWNER = "TASK_LAST_OWNER";
export const TASK_OWNER_FRONT_OFFICE_SOLVER_MMA = "TASK_OWNER_FRONT_OFFICE_SOLVER_MMA";
export const NOT_OWNER_FRONT_OFFICE_SOLVER_EPB = "NOT_OWNER_FRONT_OFFICE_SOLVER_EPB";
export const TASK_COMPLETE_KCP = "TASK_COMPLETE_KCP";
export const TASK_SUSPEND_KCP = "TASK_SUSPEND_KCP";

export const POTENTIAL_OWNER = "POTENTIAL_OWNER"; // I am potential owner